module.exports = __webpack_public_path__ + "img/f3.09f2b895.png";